import type { ValidationFn, ValidationRuleConstructor } from '../define-rule'
import type {
  RuleConstructorParameters,
  RuleErrorHandlingParams,
  RuleResolveParams
} from '../ts/rule-constructor-parameter.type'
import { type DefaultRule, DefaultRules } from '../rules/rules'

function createConfigureRuleError(ruleKey: string) {
  return new Error(`Validation Rule Constructor for key ${ruleKey} is not defined`)
}

export function configureRule(
  rule: string | DefaultRule,
  params: RuleConstructorParameters,
  errorHandling?: RuleErrorHandlingParams
): ValidationFn {
  const constructor = DefaultRules[
    rule as DefaultRule
  ] as ValidationRuleConstructor<RuleConstructorParameters>

  if (!constructor) throw createConfigureRuleError(rule)

  // When useDefaultErrorMessage is true then add errorMessage with default error messages key
  // In case there is a errorMessage defined in the params parameter it is used instead of the default error message
  if (errorHandling?.useDefaultErrorMessage && params.errorMessage === undefined) {
    const defaultMessageKey = `validation.default_error_messages.${rule}`
    const transformed =
      errorHandling.transformErrorMessage?.(defaultMessageKey, params.config) ?? defaultMessageKey
    params = {
      ...params,
      errorMessage: transformed
    }
  }

  return constructor(params)
}

export function resolveRules<T extends DefaultRule | (string & {})>(
  rules: RuleResolveParams<T>[],
  errorHandling?: RuleErrorHandlingParams
): ValidationFn[] {
  return rules.map((rule) => {
    return configureRule(
      rule.type,
      {
        config: rule.config,
        errorMessage: rule?.errorMessage
      },
      errorHandling
    )
  })
}
